/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-empty-function */
import React from 'react';

export interface DebugContextProps {
  isBreakpointDebuggerEnabled: boolean;
  setBreakpointDebuggerEnabled: (enabled: boolean) => void;
}

export const DebugContext = React.createContext<DebugContextProps>({
  isBreakpointDebuggerEnabled: false,
  setBreakpointDebuggerEnabled: (enabled: boolean) => {}
});
